module.exports = __webpack_public_path__ + "static/media/introduction.7e339a26.mp4";